module.exports = __webpack_public_path__ + "static/img/p14.7b94acec.png";